import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import _typeof from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/typeof";
import _toConsumableArray from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/drone_race_manage/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
import uploadImagetow from '@/components/uploadImagetow';
import axios from 'axios';
import * as XLSX from 'xlsx';
export default {
  mixins: [popUp],
  props: ['eventId', 'eventStatus'],
  components: {
    uploadImagetow: uploadImagetow
  },
  data: function data() {
    return {
      dialogFormVisible: false,
      formData: {
        event_id: '',
        start_date: '',
        end_date: '',
        designated: ''
      },
      value2: [],
      chooseList: [{
        label: '排除内定',
        value: true
      }]
    };
  },
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.value2 = [];
                _this.formData.start_date = '';
                _this.formData.end_date = '';
                _this.formData.event_id = _this.eventId;
                _this.dialogFormVisible = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    datechange: function datechange() {
      if (this.value2 && this.value2.length > 0) {
        this.formData.start_date = this.value2[0];
        this.formData.end_date = this.value2[1];
      } else {
        this.formData.start_date = '';
        this.formData.end_date = '';
      }
    },
    rewriteClearData: function rewriteClearData() {
      var isClear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this.clearData(isClear);
    },
    getData: function getData(data) {
      var _this2 = this;

      var responseData = data.data;
      console.log("responseData===", responseData);
      Object.keys(responseData).forEach(function (sheetKey) {
        var sheet = responseData[sheetKey];

        if (sheet && Array.isArray(sheet.data)) {
          sheet.data.forEach(function (row) {
            if (row && row['维度二'] !== undefined) {
              row['维度二'] = row['维度二'] ? _this2.$utils.formatDuration(row['维度二']) : '';
            }
          });
        }
      });
      this.exportMultiSheetExcel(responseData);
    },
    exportMultiSheetExcel: function exportMultiSheetExcel(data) {
      var _this3 = this;

      var fileName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '导出数据';

      try {
        var workbook = XLSX.utils.book_new();
        Object.keys(data).forEach(function (sheetKey) {
          var sheet = data[sheetKey];
          var sheetName = sheet.name || sheetKey;
          var headings = sheet.headings || [];
          var sheetData = sheet.data || [];
          var worksheetData = []; // 添加表头

          if (headings.length > 0) {
            worksheetData.push(headings);
          } // 处理数据（统一转换为二维数组）


          if (sheetData.length > 0) {
            if (Array.isArray(sheetData[0]) && !Array.isArray(sheetData[0][0])) {
              // 已经是二维数组，直接添加
              worksheetData.push.apply(worksheetData, _toConsumableArray(sheetData));
            } else if (_typeof(sheetData[0]) === 'object') {
              var convertedData = _this3.convertObjectToArray(sheetData, headings);

              worksheetData.push.apply(worksheetData, _toConsumableArray(convertedData));
            }
          } // 创建工作表


          var worksheet = XLSX.utils.aoa_to_sheet(worksheetData); // 设置列宽

          if (headings.length > 0) {
            var colWidths = headings.map(function (heading) {
              return {
                wch: Math.min(Math.max(heading.length * 2, 10), 30)
              };
            });
            worksheet['!cols'] = colWidths;
          }

          XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        });
        XLSX.writeFile(workbook, "".concat(fileName, ".xlsx"));
        return true;
      } catch (error) {
        console.error('导出Excel失败:', error);
        throw error;
      }
    },
    convertObjectToArray: function convertObjectToArray(data, headings) {
      if (!data || data.length === 0) return [];
      return data.map(function (row) {
        return headings.map(function (heading) {
          // 直接使用表头作为字段名取值
          var value = row[heading]; // 如果取不到，尝试常见的英文字段名映射

          if (value === undefined || value === null) {
            // 英文字段名映射
            var fieldMapping = {
              '名称': 'name',
              '赛区': 'division',
              '学校': 'school'
            };
            var englishField = fieldMapping[heading];

            if (englishField && row[englishField] !== undefined) {
              value = row[englishField];
            } else {
              value = '';
            }
          } // 处理 null 和 undefined


          if (value === null || value === undefined) return '';
          return value;
        });
      });
    }
  }
};